
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import type { CourseScheduleCardUIType } from '@xt/client/entities/my-v2/types'
import { Observer } from 'mobx-vue'
import moment from 'moment'

@Observer
@Component({
  components: {}
})
export default class CourseScheduleCard extends Vue {
  @Prop() dataSource: CourseScheduleCardUIType

  get UserStore() {
    return this.$store.$storeUser
  }

  goCourseOrLive() {
    const now = this.$ajax.serviceDate().utcOffset(+8).valueOf()
    const isLive = this.getLiveStatus(now)

    if (isLive === true) {
      // 用户需要完善个人信息
      if (this.UserStore.onneedCompleteInfo()) {
        this.UserStore.onToggleModal(this.$EnumLocaleLinks.links_complete)
        return
      }
      if (!this.dataSource.id) return
      window.open(`/live?classhour=${this.dataSource.id}`, '_blank')
    } else {
      this.$router.push({
        name: 'course-id',
        params: { id: this.dataSource.courseId.toString() }
      })
    }
  }

  getLiveStatus(now: number) {
    const { startTime, liveEnd, publishStatus } = this.dataSource

    if (!moment(now).isSame(startTime, 'day') || publishStatus !== 1) {
      return false
    }

    if (moment(now).isBefore(startTime) || !liveEnd) {
      return true
    }

    return false
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
